"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var agressoCodes = {
    AP: "ABO",
    ASK: "AAS",
    BTI: "ABT",
    BYN: "ABN",
    DNB: "ABO",
    DP: "ADP",
    MPL: "ABO",
    SA: "ABS",
    SCH: "ASN",
    STR: "AST",
    VG: "AVG",
    VNY: "AVN",
    E24: "ADP",
    BEDRIFT: "ASN",
    RB24: "ARB",
    BAREASANE: "ABA",
    OP: "AOP",
    SVD: '',
    OMNI: '',
    WELLOBE: '',
    AB: '',
    VEKTKLUBB: ''
};
var agressoCodeFromClientShortHandName = function (clientShortHandName) {
    return agressoCodes[clientShortHandName];
};
exports.default = agressoCodeFromClientShortHandName;
//# sourceMappingURL=agressoCodeFromClientShortHandName.js.map